import React, { useContext } from 'react';

import UserContext from 'contexts/UserContext';

import Button from 'components/Button';
import TestDate from 'components/Form/TestDate';
import Courses from 'containers/Administrator/Users/Create_Old/Student/Courses';
import { Input } from 'components/Form';

const Grade = ({ grade }) => {
	// Use user's context
	const { handleUser } = useContext(UserContext);

	// Handle student's grade input change
	// @event: object | native onChange event
	const onChange = event => {
		const { name, value} = event.target || event;
		if (name === 'blankId') {
			handleUser({
				type: 'ON_SELECT_BLANK_STUDENT',
				payload: {
					id: grade.id,
					name,
					value,
					courses: grade.blanks.find(blank => blank.id === Number(value)).courses
				}
			});
		} else {
			handleUser({
				type: 'ON_CHANGE_GRADE_STUDENT',
				payload: {
					id: grade.id,
					name,
					value
				}
			});
		}
	};

	// Handle student's grade removal
	const onRemove = event => {
		event.preventDefault();
		handleUser({
			type: 'ON_REMOVE_GRADE_STUDENT',
			payload: {
				id: grade.id
			}
		});
	};

	// Handle student's grade plan generation
	const onGenerate = event => {
		event.preventDefault();
		handleUser({
			type: 'ON_GENERATE_PLAN_STUDENT',
			payload: {
				id: grade.id
			}
		});
	};

	return (
		<div className="grade">
			<div className="grade__information">
				<div className="grade__title">
					{grade.title}
					<br />
					<small>{grade.program.title}</small>
				</div>

				<div className="grade__dates">
					<TestDate
						name="startDate"
						value={grade.startDate}
						onChange={onChange}
					/>

					<div className="grade__divider">•</div>

					<TestDate
						end
						name="endDate"
						value={grade.endDate}
						onChange={onChange}
					/>
				</div>

				<div className="grade__controls">
					<Button
						small
						outline
						icon="event_available"
						theme="success"
						text="Ģenerēt"
						onClick={onGenerate}
					/>

					<Button
						space
						small
						outline
						icon="delete"
						theme="danger"
						text="Noņemt"
						onClick={onRemove}
					/>
				</div>

				<div className="mt-4 flex flex-col gap-2">
					<h5>Uzņemšanas rīkojums</h5>

					<Input
						type="text"
						name="warrant"
						placeholder="Rīkojuma numurs"
					/>
				</div>

				<div className="mt-4 flex flex-col gap-2">
					<h5>Maksājumu grafiks</h5>

					<Input
						type="number"
						name="amount"
						placeholder="Summa"
					/>
				</div>
			</div>
				
			<div className="grade__courses">
				<Courses gradeId={grade.id} courses={grade.courses} />
			</div>
		</div>
	);
};

export default Grade;